import { FC, HTMLAttributes } from 'react';
import { ReactComponent as Alert } from './alert_info.svg';
import st from './FeedbackMessage.module.scss';

interface IFeedbackMessageProps extends HTMLAttributes<HTMLDivElement> {
	/** Сообщение */
	message?: string;
}

/** Компонента для отрисовки ошибки заполнения формы */
const FeedbackMessage: FC<IFeedbackMessageProps> = ({
	message = '',
	children,
	...otherProps
}) => {
	return (
		<div className={st.feedback} {...otherProps}>
			{!!message.trim() && <Alert />}
			<span className="body-small">{message}</span>
			{children}
		</div>
	);
};

export default FeedbackMessage;
